export enum AdministrativeEventTypes {
  PURCHASE_AND_SALE = 1,
  PURCHASE = 2,
  SALE = 3,
  RENTAL_INTAKE_AND_DISPENSE_ISSUANCE = 4,
  RENTAL_INTAKE_AND_DISPENSE_RETURN = 5,
  RENTAL_INTAKE_ISSUANCE = 6,
  RENTAL_INTAKE_RETURN = 7,
  RENTAL_DISPENSE_ISSUANCE = 8,
  RENTAL_DISPENSE_RETURN = 9
}
